<template>
    <div>
        <div v-if="label" class="label" >{{ label }}</div>
        <!-- if type is text -->
        <div>
            <v-select
                :index="index"
                :label="displayLabel"
                class="w-auto"
                :type="type"
                :placeholder="placeholder"
                v-model="internalValue"
                v-validate="validation"
                data-vv-validate-on="input|keyup|blur"
                :name="errorCorrelationKey"
                :options="options"
                :reduce="reduce"
                :id="id"
            />
        </div>
        <!-- error span -->
        <span class="text-danger text-sm block mt-2">{{ errors.first(this.errorCorrelationKey) }}</span>
        <!-- hint -->
        <span v-if="!errors.first(this.errorCorrelationKey) && this.hint" class="speakol-color text-sm block mt-2">{{ hint }}</span>
    </div>
</template>


<script>
export default {
  data () {
    return {
      errorCorrelationKey: ''
    }
  },
  created () {
    if (this.label) {
      this.errorCorrelationKey = this.label.toLowerCase()
    }
  },
  name: 'speakol-select',
  props: {
    reduce: {
      type: Function
    },
    displayLabel: {
      default: 'text',
      type: [String]
    },
    index: {
      default: 'value',
      type: [String]
    },
    label: {
      default: '',
      type: [String, Number]
    },
    placeholder: {
      default: 'placeholder',
      type: [String, Number]
    },
    type: {
      default: 'text',
      type: [String]
    },
    options: {
    },
    validation: {
      type: [String]
    },
    description: {

    },
    hint: { type: [String] },
    value: {},
    id:{}
  },

  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },


  methods: {
    validate () {
      return this.$validator.validate(this.errorCorrelationKey)
    },
    setDefault () {
      this.internalValue = ''
      this.$validator.reset()
    }
  }


}


</script>

<style lang="scss" scoped>

    $vs-dropdown-height: 60px;

    .label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #2c2c2c;
    }

    .speakol-color {
      color: #0092d7;
    }

    /deep/ .vs__dropdown-toggle {
      height: 40px !important;
    }

    /deep/ .vs__search::placeholder {
      color: #bdbdbd;
    }

</style>
